/**
 * Module-level ref storing React Router's navigate function.
 *
 * This allows non-React code (navigation.ts) to trigger route changes
 * without needing a React context.
 */

import type { NavigateFunction } from 'react-router';

let navigateRef: NavigateFunction | null = null;

export function setNavigateRef(nav: NavigateFunction): void {
  navigateRef = nav;
}

export function getNavigateRef(): NavigateFunction | null {
  return navigateRef;
}
